
export function isProfilePhotoDocumentType(docType: { code?: string | null; name?: string | null }): boolean {
  const code = (docType.code || '').trim().toUpperCase();
  const name = (docType.name || '').trim().toLowerCase();
  return code === 'PSP' || name === 'passport size photo';
}


const PHOTO_EXTENSIONS = ['jpg', 'jpeg', 'png'];

/** StudentPhotoService.MaxBytes - the cap the photograph write enforces. */
const PHOTO_MAX_MB = 8;


export function effectiveFileRule(docType: {
  code?: string | null;
  name?: string | null;
  allowedFileTypes?: string | null;
  allowedFileSize?: number | null;
}): { extensions: string[]; maxMb: number } {
  const configured = (docType.allowedFileTypes || '')
    .split(',')
    .map(t => t.trim().toLowerCase())
    .filter(Boolean);
  const maxMb = docType.allowedFileSize || 0;

  if (!isProfilePhotoDocumentType(docType)) {
    return { extensions: configured, maxMb };
  }

  const extensions = configured.length > 0
    ? configured.filter(ext => PHOTO_EXTENSIONS.includes(ext))
    : PHOTO_EXTENSIONS;

  return {
    extensions: extensions.length > 0 ? extensions : PHOTO_EXTENSIONS,
    maxMb: maxMb > 0 ? Math.min(maxMb, PHOTO_MAX_MB) : PHOTO_MAX_MB,
  };
}
